import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/layout/PublicNav";
import { useBrand } from "@/context/BrandContext";
import api from "@/lib/api";

const COLS = [
  { title: "Explore", links: [["Home", "/"], ["About", "/about"], ["Resources", "/resources"], ["Insights", "/blog"], ["Apply", "/apply"]] },
  { title: "Legal", links: [["Privacy Policy", "/legal/privacy"], ["Terms", "/legal/terms"], ["Refund Policy", "/legal/refund"]] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const { brand } = useBrand();
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/subscribe", { email, source: "footer" });
      toast.success("Check your inbox to confirm.");
      setEmail("");
    } catch { toast.error("Could not subscribe."); }
  };
  return (
    <footer className="relative overflow-hidden bg-footer text-white grain">
      <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Logo light />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Growth mentor for entrepreneurs. Helping experienced owners sell more, grow smarter and use AI daily.
            </p>
            <form onSubmit={subscribe} className="mt-6 flex max-w-sm gap-2" data-testid="footer-newsletter-form">
              <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                placeholder="Your email" data-testid="footer-newsletter-input"
                className="border-white/15 bg-white/5 text-white placeholder:text-slate-500" />
              <Button type="submit" data-testid="footer-newsletter-submit" className="bg-emerald text-white hover:bg-emerald-700">Subscribe</Button>
            </form>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <p className="font-heading text-sm font-semibold uppercase tracking-wider text-slate-500">{c.title}</p>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-slate-300 transition-colors hover:text-emerald">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {brand?.name || "Shubham Bapna"}. All rights reserved.</p>
          <p><Link to="/stack" className="transition-colors hover:text-emerald" data-testid="footer-stack-link">The Stack — tools I actually use.</Link></p>
        </div>
      </div>
    </footer>
  );
}
